import {BankList} from "./BankList";
import {BankEdit} from "./BankEdit";
import {BankCreate} from "./BankCreate";

export default {
    list: BankList,
    create: BankCreate,
    edit: BankEdit
};
